export default "__VITE_ASSET__RxFfMSEM__"